<template>
<div class="user-cabinet">
	<h1>{{tr('MyCabinet')}}</h1>
	<div class="alert alert-danger mt-3" v-if="error"><button type="button" class="close ml-3" @click="error = null">×</button><i class="fas fa-exclamation-triangle"></i> {{tr('Error')}}: {{error}}</div>
	<div class="main_table_container">
		<div class="main_table_block" v-for="(item, index) in data" v-bind:key="index" >
			<div v-if="item.pdf_link || (item.promo && item.promo.result && item.promo.result.length)">
				<h2>{{item.conf_name}}</h2>
				<table class="main_table">
					<thead>
					<tr class="text-center">
						<th>{{tr('Матеріали')}}</th>
						<th>{{tr('Промо')}}</th>
					</tr>
					</thead>
					<tbody>
					<tr>
						<!-- <td>{{item.conf_name}}</td> -->
						<td><a :href="item.pdf_link" v-if="item.pdf_link">{{tr('materialsPDF')}}</a></td>
						<td>
							<div v-if="item.promo && item.promo.result">
								<div v-for="(itemPromo, indexPromo) in item.promo.result" v-bind:key="indexPromo">
								<a v-if="itemPromo.promo_link" :href="itemPromo.promo_link" v-html="itemPromo.description || tr('promo')"></a>
								</div>
							</div>
						</td>
					</tr>
					</tbody>
				</table>
			</div>
		</div>
</div>
	<div class="text-center">
		<button class="btn btn-outline-success mx-2 mt-3 mb-3" @click="logout" v-if="data.length"><i class="fas fa-sign-in-alt"></i> {{tr('Logout')}}</button>
	</div>
</div>
</template>

<script>

export default {
	name: 'UserCabinet',
	components: {
	},
	inject: [
		'lng',
		'post',
		'tr',
		'setCookie',
		'getCookie',
	],
	data: function () {
		return {
			error: null,
			data: [],
			input: null
		};
	},
	created: function () {
	},

	mounted: function () {
		this.getPaticipantByToken();
	},

	methods: {
		logout: function () {
			this.setCookie('cabinet_token', '', -1);
			this.input = null;
			this.data = [];
			this.token = '';
			this.user = '';
			this.pass = '';
			this.key = null;
			window.location.href = '../';
		},

		getPaticipantByToken: function() {
			let cabinet_token = this.getCookie('cabinet_token');
			if (cabinet_token) {
				this.post(
					{
						"query": {
							"method": "check_participant",
							"include": [
								{"method": "promo"},
								{"method": "conf_link"}
							]
						},
						"language": "ua"
					},
					[
						{key: "AUTHORIZATION", value: cabinet_token}
					]
				).then((dataConf) => {
					console.log(dataConf);
					if (dataConf.resultcode == 200) {

						this.data = dataConf.check_participant.result;
						console.log(this.data);
						this.user = dataConf.check_participant.result[0].first_name + ' ' + dataConf.check_participant.result[0].last_name;
						var conf = {
							event: this.event,
							user: this.user,
							moder: dataConf.check_participant.result[0].is_moderator,
							stream: dataConf.check_participant.result[0].conf_link,
							pdf: dataConf.check_participant.result[0].pdf_link,
						};
						if (dataConf.check_participant.result[0].promo && dataConf.check_participant.result[0].promo.result && dataConf.check_participant.result[0].promo.result[0] && dataConf.check_participant.result[0].promo.result[0].promo_link) {
							conf.video = dataConf.check_participant.result[0].promo.result[0].promo_link;
						}
						this.input = conf;
						this.pass = '';
					} else {
						this.setCookie('cabinet_token', '', -1);
						if ('errormessage' in dataConf) {
							this.error = dataConf.errormessage;
						}
						window.location.href = '../';
					}
				})
					.catch((err) => {
						console.log(err);
						this.setCookie('cabinet_token', '', -1);
						window.location.href = '../';
					})
			}
			else {
				this.input = null;
				this.data = [];
				window.location.href = '../';
			}

		},

	},
}
</script>

<style>
	/*.table {*/
		/*table-layout: fixed;*/
	/*}*/

	/*.table td {*/
		/*overflow: hidden;*/
	/*}*/


	/*.user-cabinet {*/
		/*margin: 0;*/
		/*padding: 0;*/
	/*}*/
	.user-cabinet .main_table_container {
		padding: 0 20px 30px 20px;
		border-bottom: 1px solid #dddddd;
	}

	.user-cabinet .main_table_block {
		margin: auto;
		max-width: 1920px;
		text-align: center;
		padding-top: 10px;
	}

	.user-cabinet .main_table {
		margin: auto;
	}

	.user-cabinet table {
		border-collapse: collapse;
		width: 100%;
	}

	.user-cabinet table div {
		overflow-wrap: anywhere;
	}

	.user-cabinet td,	th {
		border: 1px solid #dddddd;
		padding: 8px;
		border-collapse: collapse;
	}

	.user-cabinet td {
		width: 50%;
	}

	.user-cabinet tr:nth-child(even) {
		background-color: #dddddd;
	}

	.user-cabinet thead tr:first-child {
		background: #dee2e6;
	}

	.user-cabinet h1 {
		font-size: 36px;
		font-style: italic;
		color: #e61d1d;
		margin: 20px auto;
		text-align: center;
		border-bottom: 1px solid #dddddd;
		width: 100%;
		padding-bottom: 15px;
	}

	.user-cabinet .btn-outline-success {
		color: #fff;
		background-color: red;
		text-transform: uppercase;
		border: 1px solid red;
	}
	.user-cabinet  .btn-outline-success:hover {
		color: #fff;
		background-color: #28a745;
		border-color: #28a745;
	}
</style>
